import { Box, Center, Skeleton, Text } from "@mantine/core";

interface Props {
  html?: string;
  loading: boolean;
  subject: string;
  unavailable: boolean;
}

export function SystemEmailPreviewThumbnail({
  html,
  loading,
  subject,
  unavailable,
}: Props) {
  if (loading) return <Skeleton h={78} w="100%" />;
  if (unavailable || !html) {
    return (
      <Center bg="gray.0" h={78} w="100%">
        <Text c="dimmed" size="xs">
          Preview unavailable
        </Text>
      </Center>
    );
  }
  return (
    <Box bg="var(--mantine-color-white)" h={78} pos="relative" w="100%">
      <Box
        aria-hidden="true"
        component="iframe"
        h={312}
        sandbox=""
        srcDoc={html}
        tabIndex={-1}
        title={`Thumbnail of ${subject}`}
        w={624}
        style={{
          border: 0,
          pointerEvents: "none",
          transform: "scale(0.25)",
          transformOrigin: "top left",
        }}
      />
    </Box>
  );
}
